import React, { Component } from "react";
// @material-ui/core components
import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
// services
import activityService from "services/activity.service";
// util
import Notifications from "views/Notifications/Notifications";

class FillSentence extends Component {
    
    constructor(props) {
        super(props);

        if(this.props.activity){
            this.state = {units: this.props.unity, unity: this.props.activity.unity, title: this.props.activity.title, sentence: this.props.activity.sentence, chipWords: [], notification: {show: false, message: '', type: 'info'}};
            this.updateChip();
        } else {
            this.state = {units: this.props.unity, unity: '', title: '', sentence: '', chipWords: [], notification: {show: false, message: '', type: 'info'}};
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });

        this.updateChip();
    };

    handleSubmit() {
        if(!this.props.activity){
            activityService.createActivity({type: 'fillsentence', unity: this.state.unity, title: this.state.title, sentence: this.state.sentence, correctOptions: this.state.chipWords})
            .then(res => this.showNotification('Atividade cadastrada com sucesso!', 'success'))
            .catch(err => this.showNotification('Ocorreu um erro ao tentar cadastrar atividade! ' + err, 'danger'))
        } else {
            this.handleEdit();
        }
    }

    handleEdit() {
        activityService.updateActivity(this.props.activity.id, {unity: this.state.unity, title: this.state.title, sentence: this.state.sentence, correctOptions: this.state.chipWords})
        .then(res => this.showNotification('Atividade atualizada com sucesso!', 'success'))
        .catch(err => this.showNotification('Ocorreu um erro ao tentar atualizar atividade!', 'danger'))
    }

    showNotification(message, type){
        this.setState({notification: {show: true, message: message, type: type}});
        setTimeout(() => {
            this.setState({notification: {show: false, message: '', type: 'info'}});
            this.props.onClose()
        }, 3000);
    }

    async updateChip() {
        const chips = [];

        await this.state.sentence.split('*').forEach((word, i) => {
            if(i % 2 !== 0) chips.push(word)
        })

        this.setState({chipWords: chips})
    }

    render (){
        return(
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <CustomSelect
                    labelText="Unidade" 
                    id="unity"
                    formControlProps={{
                        fullWidth: true
                    }}
                    inputProps={{
                        type: "text",
                        name: "unity",
                        value:this.state.unity,
                        onChange:this.handleChange
                    }}
                    selectItems={this.state.units}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <CustomInput 
                        labelText="Título" 
                        id="title"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            type: "text",
                            name: "title",
                            value:this.state.title,
                            onChange:this.handleChange
                        }}
                    />  
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <CustomInput 
                        labelText="Frase completa" 
                        id="sentence"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            type: "text",
                            name: "sentence",
                            value:this.state.sentence,
                            onChange:this.handleChange
                        }}
                    />  
                    <InputLabel id="label">Adicione dois asteriscos entre as palavras que deverão ser completadas. *exemplo*</InputLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={12} style={{marginTop: 20}}>
                    {
                        this.state.chipWords.map((chip, i) => {
                            return (<Chip label={chip} color="primary" variant="outlined" key={i} />)
                        })
                    }
                </GridItem>
                <CardFooter>
                    <Button color="primary" type="submit" round onClick={this.handleSubmit}>{(!this.props.activity ? 'Cadastrar' : 'Editar')}</Button>
                </CardFooter>
            {(this.state.notification.show === true) ? (<Notifications notification={this.state.notification} />) : null}
            </GridContainer>
        )
    }
}

export default (FillSentence);